export enum KfmAppItemType {
  Item = 0,
  Text = 1,
  Discount = 2,
  Surcharge = 3,
}
